var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ConstructionTaskOutlineField, KtsOutlineService } from './outline.service';
import { AlertModalService } from '../../../../component/alertmodal/alertmodal.service';
import { ValidationService } from '../../../../service/validation.service';
var KtsConstructionOutlineComponent = /** @class */ (function (_super) {
    __extends(KtsConstructionOutlineComponent, _super);
    function KtsConstructionOutlineComponent(router, route, logger, action, message, page, service, alertModalService, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.alertModalService = alertModalService;
        _this.validService = validService;
        _this.items = [];
        _this.fieldItems = {};
        _this.seq = 1;
        _this.readonly = false;
        return _this;
    }
    KtsConstructionOutlineComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setCompRec();
    };
    KtsConstructionOutlineComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsConstructionOutlineComponent.prototype.onSubscribe = function (data) {
        if (typeof data.construction_m_id !== 'undefined') {
            this.constructionMId = data.construction_m_id;
            return;
        }
        if (typeof data.items === 'undefined' || !(data.items instanceof Array) || data.items.length === 0) {
            return;
        }
        // task_outline_field_u
        if (typeof data.items[0].task_outline_field_m_id !== 'undefined') {
            this.fieldItems = {};
            var items = data.items;
            for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
                var item = items_1[_i];
                item.$type = "put" /* Put */;
                this.fieldItems[item.task_outline_field_m_id] = item;
            }
            for (var _a = 0, _b = this.items; _a < _b.length; _a++) {
                var item = _b[_a];
                for (var _c = 0, _d = item.task_outline_field_m; _c < _d.length; _c++) {
                    var field = _d[_c];
                    if (typeof this.fieldItems[field.id] === 'undefined') {
                        this.fieldItems[field.id] = Object.assign(new ConstructionTaskOutlineField(), {
                            task_other_field_m_id: field.id,
                            construction_m_id: this.constructionMId
                        });
                    }
                }
            }
        }
        // task_outline_m
        if (typeof data.items[0].project_m_id !== 'undefined') {
            this.items = [];
            var items = data.items;
            for (var _e = 0, items_2 = items; _e < items_2.length; _e++) {
                var item = items_2[_e];
                item.$seq = this.seq++;
                if (item.task_outline_field_m && item.task_outline_field_m.length > 0) {
                    this.service.sortItems(item.task_outline_field_m);
                }
                this.items.push(item);
                // init task_outline_field_u
                for (var _f = 0, _g = item.task_outline_field_m; _f < _g.length; _f++) {
                    var field = _g[_f];
                    if (typeof this.fieldItems[field.id] === 'undefined') {
                        this.fieldItems[field.id] = Object.assign(new ConstructionTaskOutlineField(), {
                            task_outline_field_m_id: field.id,
                            construction_m_id: this.constructionMId
                        });
                    }
                }
            }
        }
        this.setCompRec();
    };
    KtsConstructionOutlineComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    KtsConstructionOutlineComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#button') {
            // 必須チェック
            var event_1 = this.action.getEvent('outlineSave');
            if (typeof event_1.action === 'undefined') {
                return;
            }
            var valid = this.validService.validation('submit', event_1, this.action.getCompRec(), this.msgSnapshot);
            if (!valid.validation) {
                return;
            }
            // 確認のアラートモーダルを表示
            this.alertModalService.open({
                message: this.msgSnapshot['au.COMPONENT.KtsConstructionOutlineComponent.Modal.save.confirm'],
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#save#ok',
                        caption: this.msgSnapshot['Modal.button.ok']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#save#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
        }
        else if (e === this.componentName + '#save#ok') {
            // 工事概要保存
            this.action.firstAction('outlineSave');
        }
    };
    KtsConstructionOutlineComponent.prototype.onEvent = function (e1, e2, r) {
    };
    KtsConstructionOutlineComponent.prototype.onChangeField = function (e, key) {
        this.fieldItems[key][e.key] = e.val;
        this.setCompRec();
    };
    KtsConstructionOutlineComponent.prototype.setCompRec = function () {
        var fieldData = [];
        var fieldItems = JSOG.parse(JSON.stringify(this.fieldItems));
        for (var _i = 0, _a = Object.keys(fieldItems); _i < _a.length; _i++) {
            var key = _a[_i];
            if (!fieldItems[key].value) {
                if (typeof fieldItems[key].id === 'undefined') {
                    continue;
                }
                else {
                    fieldItems[key].$type = "delete" /* Delete */;
                }
            }
            fieldData.push(fieldItems[key]);
        }
        this.action.setCompRec(this.componentName, { items: fieldData });
    };
    KtsConstructionOutlineComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-construction-outline',
                    template: "<form id=\"{{ componentName }}\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div *ngFor=\"let item of items; let index = index;\" [class.-mt-1]=\"index > 0\">\n        <p>{{ item.name }}</p>\n        <div class=\"-mt-1 -mr-1\">\n          <ul class=\"form form-campaign\">\n            <li class=\"stageFlowPane\">\n              <div class=\"stageFlowPane_border\">\n                <div *ngFor=\"let field of item.task_outline_field_m; let fieldIndex = index;\" class=\"row -m-1\" [class.-mt-2]=\"fieldIndex > 0\">\n                  <div class=\"col-sm-12\">\n                    <column [key]=\"'form'\" [componentName]=\"componentName + '#field'\" [index]=\"item.$seq\" [col]=\"{\n                      label: field.name,\n                      key: 'value',\n                      controlType: 'text',\n                      readonly: readonly,\n                      params: {formClass: {width: '100per'}}\n                    }\" [val]=\"fieldItems[field.id]\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeField($event, field.id)\"></column>\n                  </div>\n                </div>\n              </div>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row -mt-1\">\n    <div class=\"col-sm-12\">\n      <btn [componentName]=\"componentName + '#button'\"\n           [component]=\"{\n             params: {\n               buttons: [{\n                 type: 'button',\n                 event: componentName + '#button',\n                 caption: (msg | async)['Button_save']\n               }]\n             }\n           }\"></btn>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsConstructionOutlineComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsOutlineService },
        { type: AlertModalService },
        { type: ValidationService }
    ]; };
    return KtsConstructionOutlineComponent;
}(ContentBaseComponent));
export { KtsConstructionOutlineComponent };
//# sourceMappingURL=construction-outline.component.js.map